export enum InvoiceStatus {
    APPROVED = "APPROVED",
    PENDING = "PENDING",
    DECLINED = "DECLINED",
    IN_REVIEW = "IN REVIEW",
}